import {
  TRIGGER_PLAYWRIGHT_REGRESSION_REQUEST,
  TRIGGER_PLAYWRIGHT_REGRESSION_SUCCESS,
  TRIGGER_PLAYWRIGHT_REGRESSION_FAILURE,
  RESET_PLAYWRIGHT_REGRESSION_STATE,
} from "../actions/playwrightRegressionActions";

const initialState = {
  submitStatus: "idle", // idle | submitting | success | error
  lastRunId: null,
  error: null,
};

const playwrightRegressionReducer = (state = initialState, action) => {
  switch (action.type) {
    case TRIGGER_PLAYWRIGHT_REGRESSION_REQUEST:
      return {
        ...state,
        submitStatus: "submitting",
        lastRunId: action.payload?.runId || null,
        error: null,
      };

    case TRIGGER_PLAYWRIGHT_REGRESSION_SUCCESS:
      return { ...state, submitStatus: "success", error: null };

    case TRIGGER_PLAYWRIGHT_REGRESSION_FAILURE:
      return { ...state, submitStatus: "error", error: action.error };

    case RESET_PLAYWRIGHT_REGRESSION_STATE:
      return initialState;

    default:
      return state;
  }
};

export default playwrightRegressionReducer;
